/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module avi/core
 */

import {
    Directive, ElementRef, Injector, Input,
} from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Upgraded version of 'avi-icon' component, to make work in angular.
 */
@Directive({
    selector: 'avi-icon',
})
export class AviIconDirective extends UpgradeComponent {
    @Input() public type?: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('aviIcon', elementRef, injector);
    }
}
